<form [formGroup]="dataForm" class="without-default-focus">
    <div class="form-item form-item-help">
        <mat-form-field class="with-info-icon">
            <mat-label>Etape</mat-label>
            <mat-select data-select-step formControlName="step" required tabindex="10" (selectionChange)="onStepChanged($event)">
                @for (item of _steps; track item.id) {
                    <mat-option data-select-listing-type-option [value]="item.id">
                        {{ item.data.stepName }}
                    </mat-option>
                }
            </mat-select>
            @if (dataForm.errors && dataForm.errors['step']?.required && (dataForm.controls['step']?.dirty || dataForm.controls['step'].touched)) {
                <mat-error data-input-role-error>Le champ 'Etape' est obligatoire.</mat-error>
            }
        </mat-form-field>
        <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Etape" matTooltipPosition="right"></fa-icon>
    </div>
    <div class="form-item form-item-help">
        <mat-form-field class="with-info-icon">
            <mat-label>Etat</mat-label>
            <mat-select data-select-step formControlName="state" required tabindex="10">
                @for (item of _states; track item.id) {
                    <mat-option data-select-listing-type-option [value]="item.id">
                        {{ item.name }}
                    </mat-option>
                }
            </mat-select>
            @if (dataForm.errors && dataForm.errors['state']?.required && (dataForm.controls['state']?.dirty || dataForm.controls['state'].touched)) {
                <mat-error data-input-role-error>Le champ 'Etat' est obligatoire.</mat-error>
            }
        </mat-form-field>
        <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Etat" matTooltipPosition="right"></fa-icon>
    </div>
</form>
